<template>
  <div>
    <BpmnViewComponents :sheet_id="sheet_id" :task_id="task_id" />
  </div>
</template>
<script>
import BpmnViewComponents from "./BpmnViewComponents";

export default {
  name: 'BpmnEditor',
  components: {BpmnViewComponents  },
  data () {
    return {
      sheet_id:"",
      task_id:""
    }
  },
  mounted () {

  },
  activated() {
    this.sheet_id=this.$route.query.sheet_id
    this.task_id=this.$route.query.task_id
  },
  methods: {

  }
}
</script>
<style lang="scss">

</style>




// WEBPACK FOOTER //
// src/components/Admin/Flow/bpmn/BpmnView.vue